<template>
  <footer class="bg-gray-100 text-gray-600 py-4 text-center text-sm">
    &copy; 2026 Ridey. All rights reserved.
  </footer>
</template>

<script>
export default { name: "Footer" };
</script>
